// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle_toggleContainer__7\\+UzS {
    display: flex;
    align-items: center;
    margin: 5% 0% 5% 0%;
    width: 100%;
}

.toggle_toggleSwitch__mb2hA {
    position: relative;
    width: 60px;
    display: inline-block;
    text-align: left;
    margin-right: 12px;
}

.toggle_checkbox__HSLd0 {
    display: none;
}

.toggle_label__nSPHG {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid #A5ADBA;
    border-radius: 20px;
}

.toggle_inner__U4OPH {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0s ease-in 0s;
}

.toggle_inner__U4OPH:before,
.toggle_inner__U4OPH:after {
    float: left;
    width: 50%;
    height: 34px;
    padding: 0;
    line-height: 36px;
    color: #fff;
    font-weight: bold;
    box-sizing: border-box;
}

.toggle_inner__U4OPH:before {
    content: "";
    padding-left: 10px;
    background-color: #00875A;
    color: #fff;
}

.toggle_inner__U4OPH:after {
    content: "";
    padding-right: 10px;
    background-color: #A5ADBA;
    color: #fff;
    text-align: right;
}

.toggle_switch__OP9Td {
    display: block;
    width: 25px;
    margin: 4px;
    background: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    border: 0 solid #A5ADBA;
    border-radius: 20px;
    transition: all 0s ease-in 0s;
}

.toggle_checkbox__HSLd0:checked+.toggle_label__nSPHG .toggle_inner__U4OPH {
    margin-left: 0;
}

.toggle_checkbox__HSLd0:checked+.toggle_label__nSPHG .toggle_switch__OP9Td {
    right: 0px;
}

.toggle_disableToggle__y-SOe:after {
    background-color: #dfdfdf;
}

@media screen and (max-width: 600px) {
    .toggle_switch__OP9Td {
        width: 20px;
        margin: 2px;
    }

    .toggle_inner__U4OPH:before,
    .toggle_inner__U4OPH:after {
        width: 50%;
        height: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/toggle.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;;IAEA;;QAEI,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".toggleContainer {\n    display: flex;\n    align-items: center;\n    margin: 5% 0% 5% 0%;\n    width: 100%;\n}\n\n.toggleSwitch {\n    position: relative;\n    width: 60px;\n    display: inline-block;\n    text-align: left;\n    margin-right: 12px;\n}\n\n.checkbox {\n    display: none;\n}\n\n.label {\n    display: block;\n    overflow: hidden;\n    cursor: pointer;\n    border: 0 solid #A5ADBA;\n    border-radius: 20px;\n}\n\n.inner {\n    display: block;\n    width: 200%;\n    margin-left: -100%;\n    transition: margin 0s ease-in 0s;\n}\n\n.inner:before,\n.inner:after {\n    float: left;\n    width: 50%;\n    height: 34px;\n    padding: 0;\n    line-height: 36px;\n    color: #fff;\n    font-weight: bold;\n    box-sizing: border-box;\n}\n\n.inner:before {\n    content: \"\";\n    padding-left: 10px;\n    background-color: #00875A;\n    color: #fff;\n}\n\n.inner:after {\n    content: \"\";\n    padding-right: 10px;\n    background-color: #A5ADBA;\n    color: #fff;\n    text-align: right;\n}\n\n.switch {\n    display: block;\n    width: 25px;\n    margin: 4px;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    border: 0 solid #A5ADBA;\n    border-radius: 20px;\n    transition: all 0s ease-in 0s;\n}\n\n.checkbox:checked+.label .inner {\n    margin-left: 0;\n}\n\n.checkbox:checked+.label .switch {\n    right: 0px;\n}\n\n.disableToggle:after {\n    background-color: #dfdfdf;\n}\n\n@media screen and (max-width: 600px) {\n    .switch {\n        width: 20px;\n        margin: 2px;\n    }\n\n    .inner:before,\n    .inner:after {\n        width: 50%;\n        height: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleContainer": `toggle_toggleContainer__7+UzS`,
	"toggleSwitch": `toggle_toggleSwitch__mb2hA`,
	"checkbox": `toggle_checkbox__HSLd0`,
	"label": `toggle_label__nSPHG`,
	"inner": `toggle_inner__U4OPH`,
	"switch": `toggle_switch__OP9Td`,
	"disableToggle": `toggle_disableToggle__y-SOe`
};
export default ___CSS_LOADER_EXPORT___;
